var FONT_WEIGHT_BOLD = 600;
var FONT_WEIGHT_REGULAR = 400;
export var fontWeights = {
  body: FONT_WEIGHT_REGULAR,
  display: FONT_WEIGHT_BOLD,
  headline: FONT_WEIGHT_BOLD,
  label: FONT_WEIGHT_BOLD,
  title: FONT_WEIGHT_BOLD
};